<template>
  <section>
    <v-row v-if="!showTestForm" class="mt-10">
      <v-col cols="12">
        <v-row justify="space-between" class="align-center">
          <v-col cols="auto">
            <v-radio-group v-model="toAudit" row class="mt-0 pl-3">
              <v-radio label="En Espera" :value="1"></v-radio>
              <v-radio label="Auditado" :value="2"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-data-table
          :headers="tableHeaders"
          :items="tableData"
          :loading="isLoading"
          :options.sync="options"
          :server-items-length="totalItems"
          :footer-props="{
            'items-per-page-options': [15, 30, 50, 100],
          }"
        >
          <template v-slot:[`item.type`]="{ item }">
            {{
              item.type === "E"
                ? "Entrada"
                : item.type === "W"
                ? "WhatsApp"
                : item.type === "S"
                ? "Salida"
                : item.type === "0"
                ? ""
                : ""
            }}
          </template>
          <template v-slot:[`item.audit`]="{ item }">
            {{
              item.type === "0"
                ? "No Auditar"
                : item.type === "1"
                ? "En espera"
                : "Auditado"
            }}
          </template>
          <template v-slot:[`item.created_at`]="{ item }">
            {{ formatDate(item.created_at) }}
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-hover v-if="item.ext" v-slot:default="{ hover }">
              <v-btn
                @click="openRecordings(item)"
                text
                icon
                :color="hover ? 'accent' : 'blue-grey'"
              >
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </v-hover>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <select-recording-dialog
      :show="showSelectedRecordingsDialog"
      :dateStart="dateStart"
      :dateEnd="dateEnd"
      :extension="extension"
      @dialog:close="showSelectedRecordingsDialog = false"
      @submit:data="openTestForm"
    ></select-recording-dialog>
    <test-form
      v-if="showTestForm"
      :dialogProp="showTestForm"
      @processFormDialog:close="closeTestForm"
      :dataToForm="dataToForm"
      mode="from-audit"
    ></test-form>
  </section>
</template>

<script>
import moment from "moment";
import { PbxHttpClient } from "@/services/httpclient";
import SelectRecordingDialog from "@/components/AuditRecords/SelectRecordingDialog.vue";
import TestForm from "@/components/Tests/TestForm.vue";

export default {
  components: {
    TestForm,
    SelectRecordingDialog,
  },
  data() {
    return {
      isLoading: true,
      showTestForm: false,
      showSelectedRecordingsDialog: false,
      toAudit: 1,
      totalItems: 0,
      options: {},
      dateStart: "",
      dateEnd: "",
      extension: "",
      dataToForm: null,
      itemSelected: null,
      tableHeaders: [
        {
          text: "Extension",
          align: "left",
          value: "ext",
          width: "10%",
        },
        {
          text: "Tipo",
          align: "left",
          value: "type",
          width: "10%",
        },
        {
          text: "Cola",
          align: "left",
          value: "queues.name",
          width: "10%",
        },
        {
          text: "Numero",
          align: "left",
          value: "call_number",
          width: "10%",
        },
        {
          text: "Fecha de Tipificacion",
          align: "left",
          value: "created_at",
          width: "15%",
        },
        {
          text: "Tipificacion",
          align: "left",
          value: "typification.name",
          width: "15%",
        },
        {
          text: "Categoria",
          align: "left",
          value: "children.name",
          width: "15%",
        },
        {
          text: "Fecha de llamada",
          align: "left",
          value: "history_date",
          width: "15%",
        },
        {
          text: "Acciones",
          align: "left",
          value: "action",
          width: "10%",
        },
      ],
      tableData: [],
      typificationList: [],
    };
  },

  created() {
    this.getInfo();
  },

  watch: {
    options: {
      handler() {
        this.getInfo();
      },
      deep: true,
    },
    toAudit() {
      if (this.options.page !== 1) this.options.page = 1;
      else this.getInfo();
    },
    showTestForm(val) {
      if (!val) this.getInfo();
    },
  },

  methods: {
    async getInfo() {
      this.isLoading = true;
      const page = this.options.page || 1;
      const itemPerPage = this.options.itemsPerPage || 30;
      this.isLoading = true;
      try {
        const { data } = await PbxHttpClient.get("/quality/registers/audit", {
          params: { page, itemPerPage, audit: this.toAudit },
        });

        this.totalItems = data.total;
        this.tableData = data.data;
      } catch (err) {
        console.log("err", err);
      }
      this.isLoading = false;
    },

    openRecordings(item) {
      this.itemSelected = item;
      this.dateStart = moment(item.history_date)
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");

      this.dateEnd = moment(item.history_date)
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss");

      this.extension = String(item.ext);

      this.showSelectedRecordingsDialog = true;
    },

    openTestForm({ evaluationSelected, recordingSelected, recordingSelectedUrl }) {
      this.dataToForm = {
        evaluationSelected,
        recordingSelectedUrl,
        date: moment(this.dateStart).format("YYYY/MM/DD"),
        observations: "",
        recordings: recordingSelected,
        user_id: this.itemSelected?.user_id,
        ext: this.extension,
        queue_id: this.itemSelected?.queue_id,
        audit_id: this.itemSelected.id,
        isWhatsapp: this.itemSelected.type === "W",
        ticket_id: this.itemSelected.ticket_id,
      };
      this.showSelectedRecordingsDialog = false;
      this.showTestForm = true;
    },

    closeTestForm() {
      this.showTestForm = false;
      this.dataToForm = null;
    },

    formatDate(date) {
      return moment(date).format("DD-MM-YYYY HH:mm");
    },
    // async formatTypification(id) {
    //   try {
    //     const {data} = await PbxHttpClient.get(`/clients/typification/index_select/${id}`)
    //     // const { data } = await axios.get(
    //     //   `${process.env.VUE_APP_URL_BASE}:8096/api/temporary_table/index_select/${id}`,
    //     //   {
    //     //     headers: {
    //     //       Authorization: `Bearer ${localStorage.getItem("token")}`,
    //     //     },
    //     //   }
    //     // );
    //     console.log("data test", data);
    //   } catch (err) {
    //     console.log("err", err);
    //   }
    // },
  },
};
</script>
